import {
  put, takeLatest, takeEvery, select, all,
} from 'redux-saga/effects';
import {
  TeammoApi,
  normalize,
  compilePaginationObject,
} from 'app/utils/redux/helpers';
import { paymentRecordSchema, paymentRecordListSchema } from 'app/utils/redux/schemas';
import { handleError } from 'app/utils/handlers/handleError';
import { loadingStart, loadingFinish } from 'app/ducks/loading/actions';
import { sagaActions } from 'app/ducks/paymentRecords/actions';
import { PaymentRecordsActionTypes as types } from 'app/ducks/paymentRecords/types';

function* createPaymentRecordsaga(action): any {
  yield put(sagaActions.createPaymentRecordPending(action.payload));
  const [error, response] = yield (yield TeammoApi(yield select())).paymentRecords.create(
    action.payload,
  );

  if (response) {
    const normalizedResponse = normalize(response, paymentRecordSchema);

    yield put(sagaActions.createPaymentRecordsuccess(normalizedResponse));
  } else {
    yield put(
      handleError(
        error,
        sagaActions.createPaymentRecordFailed(_.isEmpty(error) ? {} : error.response.data.errors),
      ),
    );
  }
}

function* updatePaymentRecordsaga(action): any {
  yield put(sagaActions.updatePaymentRecordPending(action.payload));
  const [error, response] = yield (yield TeammoApi(yield select())).paymentRecords.update(
    action.payload,
  );

  if (response) {
    const normalizedResponse = normalize(response, paymentRecordSchema);

    yield put(sagaActions.updatePaymentRecordsuccess(normalizedResponse));
  } else {
    yield put(
      handleError(
        error,
        sagaActions.updatePaymentRecordFailed(_.isEmpty(error) ? {} : error.response.data.errors),
      ),
    );
  }
}

function* getPaymentRecordsaga(action): any {
  yield put(sagaActions.getPaymentRecordPending());
  const [error, response] = yield (yield TeammoApi(yield select())).paymentRecords.show(
    action.payload,
  );
  if (response) {
    const normalizedResponse = normalize(response, paymentRecordSchema);
    yield put(sagaActions.getPaymentRecordsuccess(normalizedResponse));
    return normalizedResponse.entities.teams[normalizedResponse.result];
  }
  yield put(
    handleError(error, sagaActions.getPaymentRecordFailed(_.isEmpty(error) ? {} : error.response.data.errors)),
  );
  return null;
}

function* getAllPaymentRecordsSaga(action): any {
  yield put(
    sagaActions.getAllPaymentRecordsPending(action.payload.compile ? action.payload.pagination : {}),
  );
  yield put(loadingStart());

  const paginationObject = action.payload.compile
    ? compilePaginationObject(yield select((state) => state.paymentRecords.pagination))
    : action.payload.pagination;

  const [error, response] = yield (yield TeammoApi(yield select())).paymentRecords.list(
    paginationObject,
  );

  if (response) {
    const normalizedResponse = normalize(response, paymentRecordListSchema);

    yield put(
      sagaActions.getAllPaymentRecordsSuccess(normalizedResponse, response.meta),
    );
    yield put(loadingFinish());
  } else {
    yield put(
      error,
      sagaActions.getAllPaymentRecordsFailed(_.isEmpty(error) ? {} : error.response.data.errors),
    );
  }
}

/* ********************************* SAGA WATCHERS ********************************* */

function* createPaymentRecordsagaWatcher(): any {
  yield takeLatest(types.CREATE_PAYMENTRECORD_REQUESTED, createPaymentRecordsaga);
}

function* updatePaymentRecordsagaWatcher(): any {
  yield takeLatest(types.UPDATE_PAYMENTRECORD_REQUESTED, updatePaymentRecordsaga);
}

function* getPaymentRecordsagaWatcher(): any {
  yield takeEvery(types.GET_PAYMENTRECORD_REQUESTED, getPaymentRecordsaga);
}

function* getAllPaymentRecordsSagaWatcher(): any {
  yield takeEvery(types.GET_ALL_PAYMENT_RECORDS_REQUESTED, getAllPaymentRecordsSaga);
}

export default function* root(): any {
  yield all([
    createPaymentRecordsagaWatcher(),
    updatePaymentRecordsagaWatcher(),
    getPaymentRecordsagaWatcher(),
    getAllPaymentRecordsSagaWatcher(),
  ]);
}
